import type {ColGroupDef, EditableCallbackParams, ICellRendererParams} from "ag-grid-community";
import {useTranslation} from "react-i18next";
import {NewUpsellingRateMatrix} from "../../../../api/types/upsellingRateDetail";
import {useTheme} from "@mui/material";
import {useEffect, useState} from "react";

export const useMatrixColDefs = ({
                                     matrixData,
                                     editable
                                 }: {
    matrixData: NewUpsellingRateMatrix;
    editable: boolean;
}): ColGroupDef[] => {
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Theme
    const theme = useTheme();

    // Use State
    const [content, setContent] = useState<NewUpsellingRateMatrix | null>(null);

    // Use Effect
    useEffect(() => {
        if (matrixData) setContent(JSON.parse(JSON.stringify(matrixData)));
    }, [matrixData]);

    const cellValueSetter = (params: any) => {
        if (params?.newValue !== null && params?.newValue !== undefined) {
            params.newValue = (params.newValue + '').replace(/,/g, '.');
        }
        if (!Number(params.newValue) && params.newValue != 0) {
            return false;
        } else if (params.newValue > 100 && params.newValue < 0) {
            return false;
        }
        params.data[params.colDef.field.split(".")[0]] = {
            ...params.data[params.colDef.field.split(".")[0]],
            amount: params.newValue
        };
        return true;
    };

    return [
        {
            children: [{
                headerName: t("pricing:upsellingRate.table.headers.reservedCarGroups"),
                headerTooltip: t("pricing:upsellingRate.table.headers.reservedCarGroups"),
                field: "reservedCarGroup",
                width: 240,
                editable: false,
                pinned: "left"
            }]
        },
        {
            headerName: t("pricing:upsellingRate.form.labels.updatedCarGroups"),
            headerClass: ["bordersRight"],
            children: (content || {matrixColumns: []}).matrixColumns.map((carGroup, index) => ({
                headerName: carGroup,
                headerTooltip: carGroup,
                field: `${carGroup}.amount`,
                minWidth: 150,
                editable: (params: EditableCallbackParams) => {
                    return editable ? Boolean(params.data && params.data[carGroup]) : editable;
                },
                valueSetter: cellValueSetter,
                cellEditor: "customEditor",
                cellRenderer: (params: ICellRendererParams) => {
                    const detail = params.data && params.data[carGroup];
                    return !detail ? null : detail?.amount + "%";
                },
                flex: 1,
                headerClass: ["bordersRight"],
                cellStyle: (params: { data: { [x: string]: any; }; }) => ({
                    justifyContent: "flex-end",
                    textAlign: "right",
                    padding: 5,
                    borderRight: "2px solid #E0E0E0",
                    backgroundColor: params.data && params.data[carGroup] ? "" : theme.palette.neutral.light
                })
            }))
        },
        {
            children: [{
                field: "upsellingRateId",
                hide: true
            }]
        }
    ];
};
